import { render, staticRenderFns } from "./RootMenuView.vue?vue&type=template&id=ae35ed16&"
import script from "./RootMenuView.vue?vue&type=script&lang=ts&"
export * from "./RootMenuView.vue?vue&type=script&lang=ts&"
import style0 from "./RootMenuView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports